// Dependencies
import React from 'react';
import { ThemeContext } from '../../components/theme/Theme.jsx';
import radium from 'radium';
import { connect } from 'react-redux';
import { validateOrderData } from '../../redux/orderReducer';
import Button from '../../components/button/Button.tsx';
import DisplaySubtotal from '../../pages/checkout/DisplaySubtotal.jsx';
// import checkoutTransitioner from '../../lib/checkoutTransitioner'

function Checkout(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		checkoutContainer: {
			margin: context.themeManager
				.value('checkout-box', 'margin-mobile', 'section-margin-mobile'),
			'@media(min-width : 768px)': {
				margin: context.themeManager
					.value('checkout-box', 'margin-mobile', 'section-margin-desktop'),
			},
		},
		buttonContainer: {
			width: '100%',
			'@media(min-width : 768px)': {
				width: '230px',
			},
		},
	};

	return (
		<div style={style.checkoutContainer}>
			<DisplaySubtotal subtotal={props.subtotal} />
			<Button
				name="goToPayment"
				buttonText={props.subtotal > 0 ?
					context.themeManager.getThemeTextOrHardcodedDefault('buttonTextContinueToPayment') :
					context.themeManager.getThemeTextOrHardcodedDefault('buttonTextContinueCheckoutNoPayment')
				}
				onClick={props.validateOrderDataAndGoToPayment}
				btnStyle="highlight"
				buttonContainerStyle={style.buttonContainer}
			/>
		</div>
	);
}

const mapStateToProps = () =>
	({});

const mapDispatchToProps = (dispatch, ownProps) => ({
	validateOrderDataAndGoToPayment: () => {
		dispatch(
			validateOrderData(
				ownProps.eventUUID,
				ownProps.selectedShipmentType)
		);
	},
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(radium(Checkout));
